<script lang="ts">
	import { findPropsByApiKey } from '@app/utils/kyc';
	import InputsAddresses from './InputsAddresses.svelte';
	export let props;

	$: addressProps = findPropsByApiKey(props.questions, 'adresse');
	$: cityProps = findPropsByApiKey(props.questions, 'ville');
	$: countryProps = findPropsByApiKey(props.questions, 'pays');
	$: postalCodeProps = findPropsByApiKey(props.questions, 'codePostal');
</script>

<InputsAddresses
	classNames="text-start"
	bind:addressProps
	bind:cityProps
	bind:postalCodeProps
	bind:countryProps
	additionalAddressOption={false}
/>
